import { Component, ViewEncapsulation, Input } from '@angular/core';

@Component({
	selector: 'company-logo-section',
	templateUrl: './company-logo-section.component.html',
	styleUrls: ['./company-logo-section.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class CompanyLogoSectionComponent {
	@Input() textAlign: string;

	constructor() {}

	ngOnInit() {}
}